export default "__VITE_ASSET__DJL8agSM__"